var _a;
import { CompanyNewsTileType } from "@irati/types";
import { RowNames } from "../../types";
var COLS = 12;
var tiles = (_a = {},
    _a[RowNames.TWO_EQUAL] = [
        { ypos: 0, config: { type: CompanyNewsTileType.Empty, columnWidth: COLS / 2 } },
        { ypos: 1, config: { type: CompanyNewsTileType.Empty, columnWidth: COLS / 2 } }
    ],
    _a[RowNames.THREE_EQUAL] = [
        { ypos: 0, config: { type: CompanyNewsTileType.Empty, columnWidth: COLS / 3 } },
        { ypos: 1, config: { type: CompanyNewsTileType.Empty, columnWidth: COLS / 3 } },
        { ypos: 2, config: { type: CompanyNewsTileType.Empty, columnWidth: COLS / 3 } }
    ],
    _a[RowNames.FOUR_EQUAL] = [
        { ypos: 0, config: { type: CompanyNewsTileType.Empty, columnWidth: COLS / 4 } },
        { ypos: 1, config: { type: CompanyNewsTileType.Empty, columnWidth: COLS / 4 } },
        { ypos: 2, config: { type: CompanyNewsTileType.Empty, columnWidth: COLS / 4 } },
        { ypos: 3, config: { type: CompanyNewsTileType.Empty, columnWidth: COLS / 4 } }
    ],
    _a);
var getNewDefaultTiles = function (rowName, xpos) {
    var newTiles = tiles[rowName];
    if (!newTiles) {
        return [];
    }
    // this errors because of the way the types are autogenerated
    // @ts-ignore
    return newTiles.map(function (tile) { return Object.assign({}, tile, { xpos: xpos }); });
};
export default getNewDefaultTiles;
